import { render, staticRenderFns } from "./ActivityGroup.vue?vue&type=template&id=8b1ea238&scoped=true&"
import script from "./ActivityGroup.vue?vue&type=script&lang=js&"
export * from "./ActivityGroup.vue?vue&type=script&lang=js&"
import style0 from "./ActivityGroup.vue?vue&type=style&index=0&id=8b1ea238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1ea238",
  null
  
)

export default component.exports